var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderAlertWhite = function SvgHeaderAlertWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.25 9.75c0-4.549-3.701-8.25-8.25-8.25S3.75 5.201 3.75 9.75v6.75c0 1.654 1.346 3 3 3h1.576c.348 1.71 1.863 3 3.674 3a3.756 3.756 0 0 0 3.674-3h4.576zM18.75 18h-12c-.827 0-1.5-.673-1.5-1.5V9.75A6.76 6.76 0 0 1 12 3a6.76 6.76 0 0 1 6.75 6.75zm-8.861 1.5c.31.872 1.135 1.5 2.111 1.5s1.8-.628 2.112-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgHeaderAlertWhite;